// src/lib/validation/formRules.ts
import * as util from "lib/util";
import * as fmt from "lib/fmt";
import * as valid from "lib/valid";

export type ValidationRuleSet = {
	[fieldName: string]: any;
};

export function GetFormRules(field: string): ValidationRuleSet {
	const baseRules: Record<string, ValidationRuleSet> = {
		description: {
			required: "Description is required",
			// Handle whitespace only
			validate: (value) => {
				if (!valid.IsString(value)) return true;
				const trimmedValue = (value as string).TrimSpace();
				if (trimmedValue.IsEmpty()) {
					return "Description cannot be empty or contain only whitespace";
				}
				return true;
			},
			maxLength: {
				value: util.ContainmentDescriptionLength,
				message: fmt.Sprintf(
					"Description must be less than or equal to %d characters",
					util.ContainmentDescriptionLength
				),
			},
		},
		partNumber: {
			required: "Part Number is required",
			validate: (value: string) => {
				if (!valid.IsString(value)) return true;

				const trimmedValue = (value as string).TrimSpace();

				if (trimmedValue.IsEmpty()) {
					return "Part Number cannot be empty or contain only whitespace";
				}

				if (trimmedValue.Len() > util.PartNumberMaxLength) {
					return `Part Number must be ${util.PartNumberMaxLength} characters or fewer`;
				}

				return true;
			},
			maxLength: {
				value: util.PartNumberMaxLength,
				message: fmt.Sprintf(
					"Part Number must be less than or equal to %d characters",
					util.PartNumberMaxLength
				),
			},
		},
		containmentName: {
			required: "Containment Name is required",
			validate: (value: string) => {
				if (!valid.IsString(value)) return true;

				const trimmedValue = (value as string).TrimSpace();

				if (trimmedValue.IsEmpty()) {
					return "Containment Name cannot be empty or contain only whitespace";
				}

				return true;
			},
			maxLength: {
				value: util.ContainmentNameLength,
				message: fmt.Sprintf(
					"Containment Name must be less than or equal to %d characters",
					util.ContainmentNameLength
				),
			},
		},
	};

	return baseRules[field] || {};
}
